module.exports = __webpack_public_path__ + "assets/webgl/card_083_DE_L0.jpg.a2310ab9.webp";